import { FormControlLabel, Grid2, MenuItem, Switch, TextField, Button, Typography } from '@mui/material';
import React, { useState, useEffect, useDebugValue } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { setCargaGeneral } from '../Redux/GeneralDuck';
import AddIcon from '@mui/icons-material/Add'
import { Delete } from '@mui/icons-material';
import { setCargaDatos } from '../Redux/V2/ContratoRedux';

const Pagador = ({ payingCustomer, setPayingCustomer, bloquearRut }) => {
  const dispatch = useDispatch()

  const general = useSelector((store) => store.general)

  const entrevista = useSelector((store) => store.contratoV2.Entrevista)
  const pagador = useSelector((store) => store.contratoV2.Pagador)
  const defendido = useSelector((store) => store.contratoV2.Defendido)
  const actualizacion = useSelector((store) => store.contratoV2.Actualizacion)

  // 🔒 estados de contrato
  const contratoCancelado = useSelector((store) => store.contratoV2.ContratoCancelado);
  const contratoFiniquitado = useSelector((store) => store.contratoV2.ContratoFiniquitado);
  const contratoFirmado = useSelector((store) => store.contratoV2.ContratoFirmado);

  //const [disabledComponent, setDisabledComponent] = useState(false);


  const disabledComponent = actualizacion?.actualizacion?.status == 1

  const bloqueadoTotalmente =
    !!contratoCancelado?.cancelado ||
    !!contratoFiniquitado?.finiquitado || (contratoFirmado?.firmado && !disabledComponent)

  const [ocupaciones, setOcupaciones] = useState(["Dependiente", "Independiente", "Jubilado", "Cesante", "Estudiante",])
  const [clon, setClon] = useState(false);
  const [errors, setErrors] = useState({
    rut: false,
    dateContact: false,
    firstname: false,
    firstnameB: false,
    lastname: false,
    lastnameB: false,
    email: false,
    phone: false,
    birthdate: false,
    gender: false,
    maritalStatus: false,
    countryOfBirth: false,
    address: false,
    region: false,
    province: false,
    commune: false,
    companyRut: false,
    companyName: false,
    claveUnica: false,
    claveUnicaB: false,
  })

  useEffect(() => {
    const keys = ["generos", "estadoCivil", "paises", "regiones", "provincias", "comunas"];
    keys.forEach((key) => dispatch(setCargaGeneral(key)));
  }, []);

  useEffect(() => { console.log(payingCustomer) }, [payingCustomer])

  /*useEffect(() => {
    if (pagador?.identifier == null && entrevista.payingCustomerId != null) {
      dispatch(setCargaDatos("Pagador", "get", entrevista.id))
    } else if (pagador?.identifier != null) {
      setPayingCustomer(pagador)
    }
  }, [pagador])*/

  useEffect(() => {
    if (defendido && clon) {
      setPayingCustomer(defendido)
      setClon(false)
    }
    else if (defendido == null || defendido.id == null) {

      //dispatch(setCargaDatos("Pagador", "get", entrevista.payingId))
    }
  }, [defendido, clon])

  const limpiarDefendido = () => {
    if (bloqueadoTotalmente) return; // 🔒
    var aux = {}
    if (payingCustomer?.id)
      aux.id = payingCustomer?.id
    setPayingCustomer(aux)
  }

  const copiarDefendido = () => {
    if (bloqueadoTotalmente) return; // 🔒
    if (defendido) {
      var pagador = { ...payingCustomer }

      pagador.idCountry = defendido.idCountry
      pagador.idDistrito = defendido.idDistrito
      pagador.firstName = defendido.firstName
      pagador.lastName = defendido.lastName
      pagador.identifier = defendido.identifier
      pagador.email = defendido.email
      pagador.telephone = defendido.telephone
      pagador.address = defendido.address
      pagador.observations = defendido.observations
      pagador.idProvince = defendido.idProvince
      pagador.idRegion = defendido.idRegion
      pagador.idEstadoCivil = defendido.idEstadoCivil
      pagador.idGenero = defendido.idGenero
      pagador.clientType = defendido.clientType
      pagador.pymeRut = defendido.pymeRut
      pagador.pymeName = defendido.pymeName
      pagador.ocupacion = ""
      setPayingCustomer(pagador)
    }
    else {
      dispatch(setCargaDatos("Defendido", "get", entrevista.clientId))
      setClon(true)
    }
  }

  const handleChange = (e) => {
    if (bloqueadoTotalmente) return; // 🔒 no permitir cambios
    const { name, value } = e.target
    setPayingCustomer((prevData) => ({ ...prevData, [name]: value }))
    //handleError(name, value)
    if (name == "clientType" && value === 1) {
      setPayingCustomer((prevData) => ({ ...prevData, companyRut: '', companyName: '' }))
      //setErrors((prevData) => ({ ...prevData, companyRut: false, companyName: false }))
    }
  };

  const handleSubmit = async (e) => {
    if (bloqueadoTotalmente) return; // 🔒
    if (actualizacion?.actualizacion?.status == 1) { //si es actualizacion en curso
      var payloadPagador = {
        json: JSON.stringify(payingCustomer),
        model: "pagador",
        actualizacionId: actualizacion.actualizacion.id,
      }
      var exitoPagador = await dispatch(setCargaDatos("Actualizacion", "put", payloadPagador));
      return
    }
  }

  return (
    <>
      <Grid2
        container
        spacing={2}
        sx={{ mt: 2, p: 3 }}
      >
        {/* —— Título —— */}
        <Grid2 size={12} sx={{ mb: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 700 }}>
            DATOS PAGADOR
          </Typography>
        </Grid2>

        <Grid2 sx={{ mb: 3 }} size={6}>
          <Button onClick={limpiarDefendido} variant="outlined" startIcon={<Delete />} disabled={bloqueadoTotalmente}> Limpiar </Button>
          <Button onClick={copiarDefendido} variant="contained" startIcon={<AddIcon />} sx={{ ml: 3 }} disabled={bloqueadoTotalmente}> Copiar Datos Cliente </Button>
        </Grid2>
        <Grid2 sx={{ mb: 3 }} size={6}>
        </Grid2>
        <Grid2 sx={{ mb: 3 }} size={6}>
          <TextField required fullWidth label="Rut"
            name="identifier"
            value={payingCustomer?.identifier ?? ''}
            onChange={handleChange}
            helperText={errors.identifier}
            InputLabelProps={{ shrink: true }}
            disabled={bloquearRut || bloqueadoTotalmente}
          />
        </Grid2>

        <Grid2 sx={{ mb: 3 }} size={6}>
          <TextField
            required
            fullWidth
            label="Nombre"
            name="firstName"
            value={payingCustomer?.firstName ?? ''}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            disabled={bloqueadoTotalmente}
          />
        </Grid2>

        {/*<Grid2 sx={{ mb: 3 }} size={6}>
        <TextField
          required
          fullWidth
          label="Nombre Secundario"
          name="firstnameB"
          value={payingCustomer?.firstnameB}
          onChange={handleChange}
        />
      </Grid2>*/}

        <Grid2 sx={{ mb: 3 }} size={6}>
          <TextField
            fullWidth
            label="Apellido"
            name="lastName"
            required
            value={payingCustomer?.lastName ?? ''}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            disabled={bloqueadoTotalmente}
          />
        </Grid2>

        {/*<Grid2 sx={{ mb: 3 }} size={6}>
        <TextField
          fullWidth
          label="Apellido Materno"
          name="lastnameB"
          required
          value={payingCustomer?.lastnameB}
          onChange={handleChange}
        />
      </Grid2>*/}

        <Grid2 sx={{ mb: 3 }} size={6}>
          <TextField
            fullWidth
            label="Correo electrónico"
            type="email"
            name="email"
            required
            value={payingCustomer?.email ?? ''}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            disabled={bloqueadoTotalmente}
          />
        </Grid2>

        <Grid2 sx={{ mb: 3 }} size={6}>
          <TextField
            fullWidth
            select
            label="Ocupación"
            name="ocupacion"
            required
            value={payingCustomer?.ocupacion ?? null}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            disabled={bloqueadoTotalmente}
          >
            {ocupaciones.map((oc) => (
              <MenuItem key={oc} value={oc}>{oc}</MenuItem>
            ))}
          </TextField>
        </Grid2>
        <Grid2 sx={{ mb: 3 }} size={6}>
          <TextField
            fullWidth
            label="Teléfono"
            type="tel"
            name="telephone"
            inputProps={{ maxLength: 12 }}
            value={payingCustomer?.telephone ?? ''}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
            disabled={bloqueadoTotalmente}
          />
        </Grid2>
        <Grid2 sx={{ mb: 3 }} size={6}>
          <TextField
            select
            label="Genero"
            name="idGenero"
            required
            fullWidth
            value={Number(payingCustomer?.idGenero)}
            onChange={handleChange}
            disabled={bloqueadoTotalmente}
          >
            {general?.generos?.map((gen) => (
              <MenuItem key={gen.id} value={Number(gen.id)}>{gen.description}</MenuItem>
            ))}
          </TextField>
        </Grid2>

        <Grid2 sx={{ mb: 3 }} size={6}>
          <TextField
            fullWidth
            select
            label="Estado Civil"
            name="idEstadoCivil"
            required
            value={Number(payingCustomer?.idEstadoCivil)}
            onChange={handleChange}
            disabled={bloqueadoTotalmente}
          >
            {general?.estadoCivil?.map((est) => (
              <MenuItem key={est.id} value={Number(est.id)}>{est.name}</MenuItem>
            ))}
          </TextField>
        </Grid2>
        <Grid2 sx={{ mb: 3 }} size={6}>
          <TextField
            fullWidth
            select
            label="Pais Nacimiento"
            name="idCountry"
            required
            value={Number(payingCustomer?.idCountry) ?? 1}
            onChange={handleChange}
            disabled={bloqueadoTotalmente}
          >
            {general?.paises?.map((pais) => (
              <MenuItem key={pais.id} value={Number(pais.id)} >{pais.description}</MenuItem>
            ))}
          </TextField>
        </Grid2>

        <Grid2 sx={{ mb: 3 }} size={6}>
          {/* <TextField
          label="Dirección"
          fullWidth
          name='address'
          variant="outlined"
          value={payingCustomer?.address || ""}
          //onChange={(e) => setDireccion(e.target.value)}
          placeholder="Ingresa tu dirección"
          sx={{ mb: 3 }}
        /> */}
          <TextField
            label="Dirección"
            fullWidth
            name='address'
            variant="outlined"
            value={payingCustomer?.address || ""}
            onChange={handleChange}   // <--- agregar esto
            placeholder="Ingresa tu dirección"
            sx={{ mb: 3 }}
            disabled={bloqueadoTotalmente}
          />

        </Grid2>

        <Grid2 sx={{ mb: 3 }} size={6}>
          <TextField
            fullWidth
            select
            label="Region"
            name="idRegion"
            required
            value={Number(payingCustomer?.idRegion)}
            onChange={handleChange}
            disabled={bloqueadoTotalmente}
          >
            {general?.regiones?.map((reg) => (
              <MenuItem key={reg.id} value={Number(reg.id)}>{reg.description}</MenuItem>
            ))}
          </TextField>
        </Grid2>

        <Grid2 sx={{ mb: 3 }} size={6}>

          <TextField
            fullWidth
            select
            label="Provincia"
            name="idProvince"
            required
            value={Number(payingCustomer?.idProvince)}
            onChange={handleChange}
            disabled={bloqueadoTotalmente}
          >
            {general?.provincias?.map((prov) => (
              <MenuItem key={prov.id} value={Number(prov.id)}>{prov.description}</MenuItem>
            ))}
          </TextField>
        </Grid2>

        <Grid2 sx={{ mb: 3 }} size={6}>

          <TextField
            fullWidth
            select
            label="Comuna"
            name="idDistrito"
            required
            value={Number(payingCustomer?.idDistrito)}
            onChange={handleChange}
            disabled={bloqueadoTotalmente}
          >
            {general?.comunas?.map((com) => (
              <MenuItem key={com.id} value={Number(com.id)}>{com.description}</MenuItem>
            ))}
          </TextField>
        </Grid2>

        <Grid2 sx={{ mb: 3 }} size={2}>
          <Grid2 sx={{ mb: 3 }} size={2}>
            <FormControlLabel
              control={
                <Switch
                  checked={payingCustomer?.clientType === 2}
                  onChange={(e) => handleChange({ target: { name: "clientType", value: e.target.checked ? 2 : 1 } })}
                  name="clientType"
                  color="primary"
                  disabled={bloqueadoTotalmente}
                />
              }
              label={payingCustomer?.clientType === 2 ? "Cliente Jurídico" : "Cliente Natural"}
            />
          </Grid2>
        </Grid2>
        <Grid2 sx={{ mb: 3 }} size={5}>
          <TextField fullWidth label="Rut Empresa"
            name="pymeRut"
            value={payingCustomer?.pymeRut ?? ''}
            onChange={handleChange}
            helperText={errors.pymeRut ?? ""}
            required={payingCustomer?.clientType == 1 ? false : true}
            hidden={payingCustomer?.clientType == 2 ? false : true}
            disabled={bloqueadoTotalmente}
          />
        </Grid2>
        <Grid2 sx={{ mb: 3 }} size={5}>
          <TextField fullWidth label="Nombre Empresa"
            name="pymeName"
            value={payingCustomer?.pymeName ?? ''}
            onChange={handleChange}
            helperText={errors.pymeName ?? ""}
            required={payingCustomer?.clientType == 1 ? false : true}
            hidden={payingCustomer?.clientType == 2 ? false : true}
            disabled={bloqueadoTotalmente}
          />
        </Grid2>
        {(actualizacion?.actualizacion?.status == 1) ?
          <Grid2 sx={{ mb: 3 }} size={5}>
            <Button variant='outlined' onClick={handleSubmit} disabled={bloqueadoTotalmente}>Actualizar Pagador</Button>
          </Grid2>
          : null}
      </Grid2>
    </>
  );

};

export default Pagador;
